const sessionUtils = {
    LOGIN_STATUS: 'login-state'
};

export default sessionUtils;
